import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RegistrationState } from '../../definitions/registration.interface';
import { RegistrationService } from '../../registration.service';
import { UserType } from 'projects/tmhna-portal/src/app/services/shared/shared-enums';

@Component({
	selector: 'tmhna-portal-registration-account-type',
	templateUrl: './registration-account-type.component.html',
	styleUrls: ['./registration-account-type.component.scss']
})
export class RegistrationAccountTypeComponent
{
	selectedRadioOption: string = UserType.businessAdminUser;
	@Input() set state(value: RegistrationState)
	{
		this.service.updateState(value);
	}
	get state(): RegistrationState
	{
		return this.service.state;
	}
	@Output() showContinueButton: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private readonly service: RegistrationService) {}

	onOptionChange(option: string)
	{
		if(option === UserType.individualUser)
		{
			this.showContinueButton.emit(false);
		}
		else
		{
			this.showContinueButton.emit(true);
		}
	}
}
